module.exports = __webpack_public_path__ + "static/media/bs-finland.7275aacd.png";